export const SSE_TIMEOUT = 40000
